// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pYmZJn97{display:flex;flex-direction:column;height:100vh}`, "",{"version":3,"sources":["webpack://./src/client/app/router/styles.scss"],"names":[],"mappings":"AAAA,UACE,YAAA,CACA,qBAAA,CACA,YAAA","sourcesContent":[".app {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app": `pYmZJn97`
};
export default ___CSS_LOADER_EXPORT___;
